import React, { Component } from "react";

export default class PurchaseOrderCreateForm extends Component {
  render() {
    return (
      <div className="card">
        <div className="card-header">
          <strong>New Purchase Order</strong>
        </div>
        <div className="card-block">
          <div className="row">
            <div className="col-sm-10 col-xl-6">
              <form>
                <div className={this.props.error ? "form-group row has-danger" : "form-group row"}>
                  <label className="col-sm-4 col-form-label" htmlFor="select">
                    Vendor
                  </label>
                  <div className="col-sm-8">
                    <select
                      id="select"
                      name="select"
                      className={this.props.error ? "form-control form-control-danger" : "form-control"}
                      size="1"
                      onChange={this.props.onVendorChange}
                    >
                      <option value="-1">Please select vendor</option>
                      {this.props.vendors.map((vendor, index) => {
                        return (
                          <option value={index} key={vendor.id}>
                            {vendor.name}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div className="card-footer row mr-0 ml-0">
          <button type="submit" className="btn btn-primary col-xs-6" onClick={this.props.submitPurchaseOrder}>
            Submit
          </button>
          <button type="reset" className="btn btn-danger col-xs-6" onClick={this.props.cancelPurchaseOrder}>
            Cancel
          </button>
        </div>
      </div>
    );
  }
}
